import styled, { css } from "styled-components";
import { NavLink } from "react-router-dom";
import { IStyleProps } from "./interfaces";

export const StyledMenu = styled.div< IStyleProps>`
    border-bottom: ${p => p.theme.c.greyD} solid 1px;
    ${p =>
        p.theme.sm.min(css`
            display: flex;
        `)}
    ${p =>
        p.isCovid &&
        css`
            display: flex;
        `}
    width: 100%;
    margin-bottom: 28px;
    ${p =>
        p.theme.xs(css`
            overflow-x: auto;
        `)}
`;

export const MenuLeft = styled.div< IStyleProps>`
    display: flex;
    align-items: flex-end;
    ${p =>
        p.simulation &&
        css`
            pointer-events: none;
        `}
`;

export const MenuRight = styled.div<IStyleProps>`
    display: flex;
    justify-content: flex-end;
    flex: 1;
    .button {
        margin-bottom: 0;
    }

    ${p =>
        p.theme.withNotch(css`
            padding-bottom: calc(env(safe-area-inset-bottom) / 2);
        `)}

    ${p =>
        !p.isCovid &&
        p.theme.xs(css`
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 10;
            background-color: ${p => p.theme.c.snow};
            box-shadow: 0 0 10px 0 ${p => p.theme.c.blackShadow3};
            margin: 0 0;
            height: 58px;
        `)}
`;

const menuElementCss = css`
    display: inline-block;
    margin: 0;
    font-size: 16px;
    margin-left: 16px;
    padding: 8px;
    cursor: pointer;
    font-weight: 600;
    color: ${p => p.theme.c.grey7};
    border-bottom: 3px solid transparent;

    &.Active {
        color: ${p => p.theme.c.boost};
        border-bottom-color: ${p => p.theme.c.boost};
    }
`;

export const MenuElement = styled(NavLink)`
    ${menuElementCss}
    white-space: nowrap;
`;

export const AlertIconWrapper = styled.div`
    margin: 0;
    .i-alert {
        color: ${p => p.theme.c.info};
        font-size: 18px;
        margin-left: 4px;
        transform: translateY(2px);
        display: block;
    }
`;

export const Center = styled.div`
    text-align: center;
`;

export const TotalViews = styled.div`
    display: flex;
    align-items: center;
    color: ${p => p.theme.c.greyA};
    margin-right: 8px;
    padding-top: 6px;
    .i-view {
        font-size: 40px;
        color: ${p => p.theme.c.greyA};
        display: inline-block;
    }
`;


export const CovidHint = styled.div`
    line-height: 30px;
    font-size: 22px;
    padding-bottom: 8px;
    .i-arrowback {
        font-size: 32px;
        display: inline-block;
        transform: scale(-1, 1) translateY(6px);
        color: ${p => p.theme.c.black};
    }
`;
